import { Button, Descriptions, Divider, List, Modal, Tag } from "antd";
import DateCustom from "../../../../hook/DateCustom";
import dayjs from "dayjs";

const AppointmentData = ({ open, close, dataRec, date, panel }) => {
  const [convertDateThai] = DateCustom();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const renderData = () => {
    const sortedData = dataRec.sort(
      (a, b) =>
        dayjs(a.considerationDate).valueOf() -
        dayjs(b.considerationDate).valueOf(),
    );

    return sortedData;
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const renderColor = (value) => {
    console.log("value", value);

    let color = "red";
    if (value === 5) color = "blue";

    let status = "ดำเนินการ";
    if (value === 5) status = "รอพิจารณา";

    return { color, status };
  };

  return (
    <Modal
      title={
        panel === "month"
          ? `รายละเอียดนัดหมาย | วันที่ ${convertDateThai(date)}`
          : `รายละเอียดนัดหมาย | เดือน ${dayjs(date)
              .add(543, "year")
              .format("MMMM YY")}`
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={700}
    >
      {dataRec.length === 0 ? (
        <div style={{ textAlign: "center", color: "#999" }}>ไม่พบข้อมูล</div>
      ) : (
        <List
          itemLayout="vertical"
          dataSource={renderData(dataRec)}
          renderItem={(item, index) => (
            <List.Item key={index}>
              <Descriptions
                size="small"
                column={1}
                bordered
                styles={{ fontWeight: "bold" }}
              >
                <Descriptions.Item label="เลขที่สัญญา">
                  {item.CONTNO || "ไม่ระบุ"}
                </Descriptions.Item>
                <Descriptions.Item label="เลขคดีดำ">
                  {item.blackNumber || "ไม่ระบุ"}
                </Descriptions.Item>
                <Descriptions.Item label="ศาล">
                  {item.provincialCourt || "ไม่ระบุ"}
                </Descriptions.Item>
                <Descriptions.Item label="เวลา">
                  <Tag color={"red"}>
                    {panel === "year"
                      ? `วันที่ ${convertDateThai(
                          item.considerationDate,
                        )} เวลา `
                      : null}
                    {dayjs(item.considerationDate).format("HH:mm")} น.
                  </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="เรื่อง">
                  {item.subject || "ไม่ระบุ"}
                </Descriptions.Item>
                <Descriptions.Item label="จำเลย">
                  {`${item.SNAM}${item.NAME1} ${
                    item.NAME2 ? item.NAME2 : ""
                  } (${item.CUSCOD})` || "ไม่ระบุ"}
                </Descriptions.Item>

                <Descriptions.Item label="สถานะ">
                  <Tag color={renderColor(item.currentStatus).color}>
                    {renderColor(item.currentStatus).status}
                  </Tag>
                </Descriptions.Item>
                {ROLE_ID === "1" || ROLE_ID === "2" ? (
                  <Descriptions.Item label="เจ้าของคดี">
                    {item.USERNAME}
                  </Descriptions.Item>
                ) : null}
              </Descriptions>
              {index !== dataRec.length - 1 && <Divider />}
            </List.Item>
          )}
        />
      )}
      <div style={{ textAlign: "center" }}>
        <Button
          onClick={handleCancel}
          style={{ color: "red", marginRight: "20px" }}
        >
          ปิด
        </Button>
      </div>
    </Modal>
  );
};
export default AppointmentData;
